<template>
  <parts @remove="$emit('remove')" :cols="2" title="紹介">
    <td width="60px">
      <icon-dropdown class="icon" :list="iconList" v-model="form.iconId"
        width="60px" height="60px"
      />
    </td>
    <td>
      <b-form-input v-model="form.name"
        placeholder="名前"
      />
      <b-form-input v-model="form.memo"
        placeholder="メモ"
      />
      <remark-editor class="text" v-model="form.note"
        :warn="100" :danger="200"></remark-editor>
    </td>
  </parts>
</template>

<script>
import parts from './parts'
import RemarkEditor from '@/components/RemarkEditor'
import IconDropdown from '@/components/IconDropdown'
export default {
  props:{
    options: Object,
    iconList: Array
  },
  components:{
    parts,
    IconDropdown,
    RemarkEditor
  },
  data () {
    return {
      form: {
        name: this.options.name,
        memo: this.options.memo,
        note: this.options.note,
        iconId: this.options.iconId
      },
    }
  },
  watch: {
    'form.name': function(){
      this.$emit('input', this.form)
    },
    'form.memo': function(){
      this.$emit('input', this.form)
    },
    'form.note': function(){
      this.$emit('input', this.form)
    },
    'form.iconId': function(){
      this.$emit('input', this.form)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
